import type {
  IContextMutationResult,
} from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import {
  useContextMutation,
} from '@modules/core/services/query';

import type {
  ITableColumnFilterSaveResponse,
  ITableFilterSaveColumnPayload,
} from '../types';
import {
  TABLE_ADD_FILTER_COLUMN_MUTATION_KEY,
  TABLE_ADD_FILTER_COLUMN_URL,
  TABLES_PERMISSIONS,
} from '../constants';

export default function useAddTableFilterColumnMutation(): IContextMutationResult<ITableColumnFilterSaveResponse, Error, ITableFilterSaveColumnPayload> {
  const { fetchPut } = useRestClient();

  return useContextMutation<ITableColumnFilterSaveResponse, Error, ITableFilterSaveColumnPayload>({
    mutationKey: [TABLE_ADD_FILTER_COLUMN_MUTATION_KEY],
    mutationFn: (payload) => {
      const { filterId, columnName, ...body } = payload;

      return fetchPut(
        TABLE_ADD_FILTER_COLUMN_URL,
        body,
        {
          permission: TABLES_PERMISSIONS.FILTERSETS_SHOW,
          urlParams: {
            filterId,
            columnName,
          },
        },
      );
    },
  });
}
